import { cn } from '@/lib/utils'

export function Spinner({ className }: { className?: string }) {
    return (
        <span
            aria-hidden="true"
            className={cn('inline-block size-6 animate-spin rounded-full border-2 border-current/25 border-t-current', className)}
        />
    )
}
